
























































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import _ from "lodash";
import Util from "../../../lib/util";
import { mixins } from "vue-class-component";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
@Component
export default class ViewWarrantyActivation extends mixins(
  DateTimeMixin,
  AbpBase
) {
  @Prop({ type: Boolean, default: false })
  value: boolean;
  @Prop({ type: String, default: "" }) hiddenCode: string;
  spinShow: boolean = false;
  namespace = "warrantyActivation";
  collectionCode: any = {};
  histories = [];
  lineLoading = false;
  async getCollectionCode() {
    this.spinShow = true;
    this.$store
      .dispatch({
        type: `${this.namespace}/get`,
        data: {
          hiddenCode: this.hiddenCode,
        },
      })
      .then((result) => {
        this.collectionCode = result;
        if (!_.isNil(this.collectionCode)) {
          this.getHistories();
        }
      })
      .finally(() => {
        this.spinShow = false;
      });
  }
  async getHistories() {
    this.lineLoading = true;
    this.$store
      .dispatch({
        type: `${this.namespace}/getChangeHistories`,
        data: {
          id: this.collectionCode.id,
        },
      })
      .then((result) => {
        this.histories = result;
      })
      .finally(() => {
        this.lineLoading = false;
      });
  }
  reset() {
    this.collectionCode = {};
    this.histories = [];
  }
  cancel() {
    this.reset();
    (this.$refs.viewActivationInfoForm as any).resetFields();
    (this.$refs.changeHistoriesForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.getCollectionCode();
    }
  }
  created() {}
  lineColumns = [
    {
      title: Util.L("Info"),
      width: 200,
      key: "propertyName",
      render: (h: any, params: any) => {
        return h("span", this.L(params.row.propertyName));
      },
    },
    {
      title: Util.L("OldValue"),
      width: 250,
      key: "originalValue",
    },
    {
      title: Util.L("NewValue"),
      width: 250,
      key: "newValue",
    },
  ];
}
